const translations = {
    activeStatus: 'Active',
    emailHeaderTitle: 'Email',
    inactiveStatus: 'Inactive',
    nameHeaderTitle: 'Name',
    roleHeaderTitle: 'Role',
    statusHeaderTitle: 'Status'
};

export default translations;
